module.exports = __webpack_public_path__ + "img/oralTest_sub32_2.2db9f87f.jpg";